import { Injectable, inject } from '@angular/core';
import { FolderService } from '../../../../../../services/folder.service';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { globalStore } from '../../../../../shared/shared.global-service';

interface State {
}

const defaultState: State = {};

@Injectable()
export class FolderFormsRecordModalStore extends ComponentStoreFactory<State> {

    public readonly folderGql = inject(FolderService);

    constructor() {
        super(defaultState, globalStore, inject(FolderService));
    }

}
